import { ref, watchEffect } from 'vue';

export function useBitrixUpload() {
    const bitrixAccount = ref(null);
    const isBitrixDataInputRight = ref(false);

    const bitrixUpload = ref({
        dataType: null,
        filter: {
            directions: [],
            stages: [],
            conditionType: 'AND',
            conditions: [],
            dateField: 'DATE_CREATE',
            startDate: {
                type: 'exact',
                date: null,
            },
            endDate: {
                type: 'exact',
                date: null,
            },
        },
    });

    function setBitrixAccount(newAccount) {
        bitrixAccount.value = newAccount;
    }

    function setBitrixUpload(data) {
        bitrixUpload.value = {
            dataType: data.dataType || null,
            filter: data.filter || {
                directions: [],
                stages: [],
                conditionType: 'AND',
                conditions: [],
                dateField: 'DATE_CREATE',
                startDate: {
                    type: 'exact',
                    date: null,
                },
                endDate: {
                    type: 'exact',
                    date: null,
                },
            },
        };
    }

    watchEffect(() => {
        if (bitrixAccount.value === null || bitrixAccount.value === undefined) {
            isBitrixDataInputRight.value = false;
            return;
        }

        if (!bitrixUpload.value.dataType) {
            isBitrixDataInputRight.value = false;
            return;
        }

        isBitrixDataInputRight.value = true;
    });

    return {
        bitrixAccount,
        bitrixUpload,
        isBitrixDataInputRight,
        setBitrixAccount,
        setBitrixUpload,
    };
}
